import type { StateCreator } from 'zustand';
import type { StoreState } from './index';
import { viewConfigApi, VIEW_PAGE_FRAUD0, type ViewConfig, type ViewPage } from '../services/viewConfigApi';

export interface ViewConfigSlice {
  viewConfig: Record<string, ViewConfig>;   // keyed by page
  fetchViewConfig: (page?: string) => Promise<void>;
  // CRM Stufe 4: schreibt die eigene Spaltenwahl und legt die Antwort direkt in viewConfig ab —
  // kein zweiter fetchViewConfig-Umlauf. NICHT optimistisch: der Store ändert sich erst mit der
  // Server-Antwort, also bleibt bei einem Fehlschlag einfach der vorherige Stand sichtbar (kein
  // Rollback nötig). Wirft weiter, der Aufrufer zeigt einen Toast.
  setzeSpaltenwahl: (page: string, spaltenwahl: Record<string, 'an' | 'aus'>) => Promise<void>;
  // Die Ansichten, die die AKTUELLE Rolle sehen darf — speist die Arbeitsflächen im Menü
  // (Nr. 74 Stufe 3). Leer, solange noch nicht geladen ODER wenn keine sichtbar ist.
  viewPages: ViewPage[];
  // false bis die erste Antwort da ist (Erfolg oder Fehlschlag). Der Router-Riegel wartet darauf,
  // statt einen Berechtigten beim Neuladen fälschlich hinauszuwerfen (leeres `viewPages` heißt
  // sonst nicht unterscheidbar entweder „noch nicht geladen" oder „wirklich nichts sichtbar").
  viewPagesLoaded: boolean;
  fetchViewPages: () => Promise<void>;
}

export const createViewConfigSlice: StateCreator<StoreState, [], [], ViewConfigSlice> = (set) => ({
  viewConfig: {},
  viewPages: [],
  viewPagesLoaded: false,

  fetchViewConfig: async (page = VIEW_PAGE_FRAUD0) => {
    try {
      const cfg = await viewConfigApi.getEffective(page);
      set((s) => ({ viewConfig: { ...s.viewConfig, [page]: cfg } }));
    } catch {
      // best-effort: keep whatever we had. Fraud0Leads falls back to "show all" when absent.
    }
  },

  setzeSpaltenwahl: async (page, spaltenwahl) => {
    const cfg = await viewConfigApi.setzeSpaltenwahl(page, spaltenwahl);
    set((s) => ({ viewConfig: { ...s.viewConfig, [page]: cfg } }));
  },

  fetchViewPages: async () => {
    try {
      const pages = await viewConfigApi.listPages();
      set({ viewPages: pages, viewPagesLoaded: true });
    } catch {
      // best-effort: Menü zeigt dann keine Arbeitsflächen aus der Registry, statt zu crashen —
      // aber als "geladen" zählt es trotzdem, sonst hängt der Router-Riegel für immer im Leeren.
      set({ viewPagesLoaded: true });
    }
  },
});
